"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _preact = require("preact");

var BellIcon = function BellIcon(_ref) {
    var width = _ref.width,
        height = _ref.height,
        className = _ref.className;
    return (0, _preact.h)(
        "svg",
        { xmlns: "http://www.w3.org/2000/svg", width: width, height: height, viewBox: "0 0 22 24", className: className },
        (0, _preact.h)(
            "g",
            { stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            (0, _preact.h)(
                "g",
                { transform: "translate(-912.000000, -20.000000)", stroke: "currentColor" },
                (0, _preact.h)(
                    "g",
                    { id: "ic-bell", transform: "translate(912.000000, 20.000000)" },
                    (0, _preact.h)(
                        "g",
                        { id: "Group-4" },
                        (0, _preact.h)("path", { d: "M10.8,23.5 C12.5120827,23.5 13.9,22.1120827 13.9,20.4 C13.9,19.9468238 13.8486441,19.8559987 13.7516245,19.8369597 C13.5776463,19.8028186 13.4455813,19.8274954 12.5295281,20.0501619 C11.8312634,20.2198903 11.3420985,20.3 10.8,20.3 C10.2579015,20.3 9.76873661,20.2198903 9.07047186,20.0501619 C8.1544187,19.8274954 8.02235366,19.8028186 7.84837548,19.8369597 C7.7513559,19.8559987 7.7,19.9468238 7.7,20.4 C7.7,22.1120827 9.08791728,23.5 10.8,23.5 Z", id: "Oval-4", fill: "currentColor" }),
                        (0, _preact.h)("path", { d: "M0.652187339,18.7213312 C7.87348823,20.2947329 13.6333707,20.2903648 20.9358933,18.7234783 C20.6153579,18.4038234 19.8097068,17.6775312 19.7928695,17.6614353 C18.9681658,16.8730488 18.4570169,16.1714585 18.2580688,15.370285 C17.7242122,13.2204189 17.5652204,11.9171119 17.3399154,8.86607392 C17.1287272,6.00620252 16.870442,4.84764471 15.9458717,3.47885453 C14.6458382,1.55420565 12.9470255,0.572269409 10.8510607,0.499359264 C8.65649779,0.610567121 6.93704272,1.59512264 5.65213553,3.48056145 C4.74006212,4.81891382 4.48117871,5.97173415 4.26491968,8.8157423 C4.0318742,11.880508 3.87297986,13.1703673 3.34109651,15.3122871 C3.14093135,16.1183618 2.6316926,16.8267648 1.81063129,17.6248643 C1.80002912,17.6351699 0.96323125,18.4029192 0.652187339,18.7213312 Z", id: "Rectangle-14" })
                    )
                )
            )
        )
    );
};

BellIcon.defaultProps = {
    width: 20,
    height: 20,
    color: '#ffffff'
};

exports.default = BellIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Icon/BellIcon.js
// module id = 195
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38